// extracted by mini-css-extract-plugin
export default {"shadow":"OnboardingTooltip_shadow__JzIPd"};